namespace Matrix.Workflow {
    export interface RunBookForm {
        StepId: Serenity.IntegerEditor;
        SortOrder: Serenity.IntegerEditor;
        Enabled: Serenity.BooleanEditor;
        CustomLabel: Serenity.StringEditor;
        GroupName: Serenity.StringEditor;
        StepCode: Serenity.StringEditor;
        StepDescription: Serenity.StringEditor;
        StatusCode: Serenity.StringEditor;
        SourceName: Serenity.StringEditor;
        SourceCode: Serenity.StringEditor;
        ExpectedWhen: Serenity.DateTimeEditor;
        QueuedWhen: Serenity.DateTimeEditor;
        StartedWhen: Serenity.DateTimeEditor;
        FinishedWhen: Serenity.DateTimeEditor;
        ForceTrigger: Serenity.BooleanEditor;
        ForceTriggerEnabled: Serenity.BooleanEditor;
        Dependencies: Serenity.StringEditor;
        FunctionName: Serenity.LookupEditor;
        FunctionParameters: Serenity.StringEditor;
        StdOut: Serenity.StringEditor;
        StdErr: Serenity.StringEditor;
        WorkflowInstanceId: Serenity.IntegerEditor;
        RowId: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class RunBookForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.RunBook';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RunBookForm.init)  {
                RunBookForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.StringEditor;
                var w3 = s.DateTimeEditor;
                var w4 = s.LookupEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(RunBookForm, [
                    'StepId', w0,
                    'SortOrder', w0,
                    'Enabled', w1,
                    'CustomLabel', w2,
                    'GroupName', w2,
                    'StepCode', w2,
                    'StepDescription', w2,
                    'StatusCode', w2,
                    'SourceName', w2,
                    'SourceCode', w2,
                    'ExpectedWhen', w3,
                    'QueuedWhen', w3,
                    'StartedWhen', w3,
                    'FinishedWhen', w3,
                    'ForceTrigger', w1,
                    'ForceTriggerEnabled', w1,
                    'Dependencies', w2,
                    'FunctionName', w4,
                    'FunctionParameters', w2,
                    'StdOut', w2,
                    'StdErr', w2,
                    'WorkflowInstanceId', w0,
                    'RowId', w0,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
